import aliOssUploadFun from './aliOssUpload'
import * as test from './test'
import dayjs from 'dayjs'
export default {
    //阿里云上传图片
    aliOssUpload: aliOssUploadFun.aliOssUpload,
    //测试
    test: test,
    confirm(msg, callBackFun, confirmText, cancelText) {
        uni.showModal({
            content: msg,
            confirmText: confirmText || '确定',
            cancelText: cancelText || '取消',
            success: function (res) {
                if (res.confirm) {
                    callBackFun(true)
                } else if (res.cancel) {
                    callBackFun(false)
                }
            },
        })
    },

    /**
     * toast提示
     */
    toast(title, duration = 3000, mask = false, icon = 'none') {
        if (Boolean(title) === false) {
            return
        }
        uni.showToast({
            title,
            duration,
            mask,
            icon,
        })
    },
    alert({ title, content, callback }) {
        uni.showModal({
            showCancel: false,
            title,
            content,
            success: function (res) {
                if (typeof callback === 'function') {
                    callback(res)
                }
            },
        })
    },
    /**
     * 获取一个随机数
     * @param {Object} min
     * @param {Object} max
     */
    random(min, max) {
        switch (arguments.length) {
            case 1:
                return parseInt(Math.random() * min + 1, 10)
            case 2:
                return parseInt(Math.random() * (max - min + 1) + min, 10)
            default:
                return 0
        }
    },
    // 去掉字符串中的空格
    trim(str) {
        if (!str) {
            return ''
        }
        return str.replace(/\s*/g, '')
    },
    copyTxt(txt) {
        txt += ''
        if (txt == 'null' || txt == 'undefined' || txt == '') {
            //toast("复制失败，内容为空");
            return
        }
        // #ifdef APP-PLUS
        uni.setClipboardData({
            data: txt,
        })
        // #endif

        // #ifdef H5
        if (document.queryCommandSupported('copy')) {
            let textarea = document.createElement('textarea')
            textarea.value = txt
            textarea.readOnly = 'readOnly'
            document.body.appendChild(textarea)
            textarea.select() // 选中文本内容
            textarea.setSelectionRange(0, txt.length)
            let result = document.execCommand('copy')
            textarea.remove()
        } else {
            return false
        }
        return true
        // #endif
    },
    isEmpty(v) {
        switch (typeof v) {
            case 'undefined':
                return true
            case 'string':
                if (v.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true
                break
            case 'boolean':
                if (!v) return true
                break
            case 'number':
                if (isNaN(v)) return true
                break
            case 'object':
                if (null === v || v.length === 0) return true
                for (var i in v) {
                    return false
                }
                return true
        }
        return false
    },
    // 函数参数必须是字符串，因为二代身份证号码是十八位，而在javascript中，十八位的数值会超出计算范围，造成不精确的结果，导致最后两位和计算的值不一致，从而该函数出现错误。
    // 详情查看javascript的数值范围
    checkIDCard(idcode) {
        // 加权因子
        var weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
        // 校验码
        var check_code = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']

        var code = idcode + ''
        var last = idcode[17] //最后一位

        var seventeen = code.substring(0, 17)

        // ISO 7064:1983.MOD 11-2
        // 判断最后一位校验码是否正确
        var arr = seventeen.split('')
        var len = arr.length
        var num = 0
        for (var i = 0; i < len; i++) {
            num = num + arr[i] * weight_factor[i]
        }

        // 获取余数
        var resisue = num % 11
        var last_no = check_code[resisue]

        // 格式的正则
        // 正则思路
        /*
                第一位不可能是0
                第二位到第六位可以是0-9
                第七位到第十位是年份，所以七八位为19或者20
                十一位和十二位是月份，这两位是01-12之间的数值
                十三位和十四位是日期，是从01-31之间的数值
                十五，十六，十七都是数字0-9
                十八位可能是数字0-9，也可能是X
                */
        //var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
        var idcard_patter =
            /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        // 判断格式是否正确
        var format = idcard_patter.test(idcode)

        // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
        return last === last_no && format ? true : false
    },
    // 获取url参数
    getUrlParam(url, paramName) {
        // 从 URL 中提取查询参数部分
        let queryString = url.split('?')[1]
        // 如果没有查询参数，返回空对象
        if (!queryString) {
            return {}
        }
        // 处理带有 hash 地址的情况
        const hashIndex = queryString.indexOf('#')
        if (hashIndex !== -1) {
            queryString = queryString.substring(0, hashIndex)
        }
        // 将查询参数字符串解析为键值对
        const queryParams = {}
        queryString.split('&').forEach((param) => {
            const [key, value] = param.split('=')
            // 如果值已经存在，则将其转换为数组存储
            if (queryParams[key]) {
                if (Array.isArray(queryParams[key])) {
                    queryParams[key].push(decodeURIComponent(value))
                } else {
                    queryParams[key] = [queryParams[key], decodeURIComponent(value)]
                }
            } else {
                queryParams[key] = decodeURIComponent(value)
            }
        })

        // 如果没有指定参数名称，则返回包含所有查询参数的对象
        if (!paramName) {
            return queryParams
        }
        // 如果指定了参数名称
        if (queryParams[paramName]) {
            return queryParams[paramName]
        } else {
            // 参数不存在，返回空字符串
            return ''
        }
    },
    /**
     * 数字转成汉字
     * @params num === 要转换的数字
     * @return 汉字
     * */
    toChinesNum(num) {
        let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
        let unit = ['', '十', '百', '千', '万']
        num = parseInt(num)
        let getWan = (temp) => {
            let strArr = temp.toString().split('').reverse()
            let newNum = ''
            let newArr = []
            strArr.forEach((item, index) => {
                newArr.unshift(item === '0' ? changeNum[item] : changeNum[item] + unit[index])
            })
            let numArr = []
            newArr.forEach((m, n) => {
                if (m !== '零') numArr.push(n)
            })
            if (newArr.length > 1) {
                newArr.forEach((m, n) => {
                    if (newArr[newArr.length - 1] === '零') {
                        if (n <= numArr[numArr.length - 1]) {
                            newNum += m
                        }
                    } else {
                        newNum += m
                    }
                })
            } else {
                newNum = newArr[0]
            }

            return newNum
        }
        let overWan = Math.floor(num / 10000)
        let noWan = num % 10000
        if (noWan.toString().length < 4) {
            noWan = '0' + noWan
        }
        return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num)
    },
    /**
     * 随机生成字符串
     * @param len 指定生成字符串长度
     */
    getRandomString(len) {
        let _charStr = 'abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ',
            min = 0,
            max = _charStr.length - 1,
            _str = '' //定义随机字符串 变量
        //判断是否指定长度，否则默认长度为15
        len = len || 15
        //循环生成字符串
        for (var i = 0, index; i < len; i++) {
            index = (function (randomIndexFunc, i) {
                return randomIndexFunc(min, max, i, randomIndexFunc)
            })(function (min, max, i, _self) {
                let indexTemp = Math.floor(Math.random() * (max - min + 1) + min),
                    numStart = _charStr.length - 10
                if (i == 0 && indexTemp >= numStart) {
                    indexTemp = _self(min, max, i, _self)
                }
                return indexTemp
            }, i)
            _str += _charStr[index]
        }
        return _str
    },
    // 日期格式化
    dateFormate(date, formatStr) {
        return dayjs(date).format(formatStr ? formatStr : 'YYYY-MM-DD')
    },
    //  计算年龄
    calculateAge(birthDate) {
        if (!birthDate) return ''
        const birth = dayjs(birthDate)
        const today = dayjs()
        let age = today.diff(birth, 'year')
        const monthDiff = today.diff(birth, 'month') % 12
        if (monthDiff < 0 || (monthDiff === 0 && today.diff(birth, 'day') < 0)) {
            age--
        }
        return age
    },
}
